import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-cb011714")
const _hoisted_1 = { class: "table table-striped table-bordered table-hover" }
const _hoisted_2 = { class: "thead-light text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "p-1 align-middle text-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "align-middle text-center" }
const _hoisted_8 = { class: "align-middle text-center" }
const _hoisted_9 = { class: "align-middle text-center" }
const _hoisted_10 = { class: "align-middle text-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash text-red" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "row justify-content-center" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortCaret = _resolveComponent("SortCaret")!
  const _component_NoContent = _resolveComponent("NoContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("th", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sort('name')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("messages.name")) + " ", 1),
            _createVNode(_component_SortCaret, {
              inactive: _ctx.currentSort!=='name',
              dir: _ctx.currentSortDir
            }, null, 8, ["inactive", "dir"])
          ]),
          _createElementVNode("th", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort('languageFrom')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("messages.source language")) + " ", 1),
            _createVNode(_component_SortCaret, {
              inactive: _ctx.currentSort!=='languageFrom',
              dir: _ctx.currentSortDir
            }, null, 8, ["inactive", "dir"])
          ]),
          _createElementVNode("th", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('languageTo')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("messages.target language")) + " ", 1),
            _createVNode(_component_SortCaret, {
              inactive: _ctx.currentSort!=='languageTo',
              dir: _ctx.currentSortDir
            }, null, 8, ["inactive", "dir"])
          ]),
          _createElementVNode("th", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('publisher')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("messages.Publisher")) + " ", 1),
            _createVNode(_component_SortCaret, {
              inactive: _ctx.currentSort!=='publisher',
              dir: _ctx.currentSortDir
            }, null, 8, ["inactive", "dir"])
          ]),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t("messages.Extinguish")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBooks, (book) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: book.id,
            onClick: ($event: any) => (_ctx.navigateToBook(book))
          }, [
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("img", {
                src: book.imageUrl,
                alt: _ctx.$t('messages.no cover'),
                class: "small-img"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("td", _hoisted_7, _toDisplayString(book.name), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.languageToGerman(book.languageFrom)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.languageToGerman(book.languageTo)), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(book.publisher), 1),
            _createElementVNode("td", {
              class: "align-middle text-center",
              onClick: _withModifiers(($event: any) => (_ctx.deleteBook(book)), ["stop"])
            }, _hoisted_13, 8, _hoisted_11)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.books.length === 0)
        ? (_openBlock(), _createBlock(_component_NoContent, {
            key: 0,
            text: _ctx.$t('messages.no book'),
            class: "text-center"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}